var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form",
        {
          attrs: {
            form: _vm.form,
            "label-col": { span: 12 },
            "wrapper-col": { span: 12 },
          },
        },
        [
          _c(
            "a-form-item",
            {
              attrs: {
                label: "企业名称",
                "label-col": { span: 4 },
                "wrapper-col": { span: 20 },
              },
            },
            [
              _c("a-input", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: ["name"],
                    expression: "['name']",
                  },
                ],
                attrs: { maxLength: 10, disabled: true },
              }),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "企业状态",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["regStatus"],
                            expression: "['regStatus']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "企业联系方式",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["phoneNumber"],
                            expression: "['phoneNumber']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "企业法人",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["legalPersonName"],
                            expression: "['legalPersonName']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "成立日期",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["estiblishTime"],
                            expression: "['estiblishTime']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "组织机构代码",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["orgNumber"],
                            expression: "['orgNumber']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "企业评分",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["percentileScore"],
                            expression: "['percentileScore']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "邮箱",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["email"],
                            expression: "['email']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "网址",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["websiteList"],
                            expression: "['websiteList']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "股票号",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["bondNum"],
                            expression: "['bondNum']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "股票名",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["bondName"],
                            expression: "['bondName']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "股票类型",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["bondType"],
                            expression: "['bondType']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "企业类型",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["companyOrgType"],
                            expression: "['companyOrgType']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "统一社会信用代码",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["creditCode"],
                            expression: "['creditCode']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "工商注册号",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["regNumber"],
                            expression: "['regNumber']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "纳税人识别号",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["taxNumber"],
                            expression: "['taxNumber']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "组织机构代码",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["orgNumber"],
                            expression: "['orgNumber']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "更新时间",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["updateTimes"],
                            expression: "['updateTimes']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "行业",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["industry"],
                            expression: "['industry']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "纳税人识别号",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["taxNumber"],
                            expression: "['taxNumber']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "核准日期",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["approvedTime"],
                            expression: "['approvedTime']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "注册资本",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["regCapital"],
                            expression: "['regCapital']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "实收注册资金",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["actualCapital"],
                            expression: "['actualCapital']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "人员规模",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["staffNumRange"],
                            expression: "['staffNumRange']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "登记机关",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["regInstitute"],
                            expression: "['regInstitute']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "是否小微企业",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["isMicroEnt"],
                            expression: "['isMicroEnt']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "企业标签",
                        "label-col": { span: 8 },
                        "wrapper-col": { span: 16 },
                      },
                    },
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["tags"],
                            expression: "['tags']",
                          },
                        ],
                        attrs: { disabled: true },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-form-item",
            {
              attrs: {
                label: "注册地址",
                "label-col": { span: 4 },
                "wrapper-col": { span: 20 },
              },
            },
            [
              _c("a-input", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: ["regLocation"],
                    expression: "['regLocation']",
                  },
                ],
                attrs: { disabled: true },
              }),
            ],
            1
          ),
          _c(
            "a-form-item",
            {
              attrs: {
                label: "经营范围",
                "label-col": { span: 4 },
                "wrapper-col": { span: 20 },
              },
            },
            [
              _c("a-textarea", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: ["businessScope"],
                    expression: "['businessScope']",
                  },
                ],
                staticClass: "business_scope",
                attrs: { disabled: true, autosize: _vm.yes },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { width: "100%", "text-align": "center" } },
        [
          _c(
            "a-button",
            {
              attrs: { type: "danger" },
              on: {
                click: function ($event) {
                  return _vm.goReceive(false)
                },
              },
            },
            [_vm._v("立即领取")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }